/**
 * Which landing page the sections are rendering for.
 *
 * The section components are shared between the studio page (/) and the
 * salon page (/salons). Each view provides its own content object; a section
 * reads its part with useLanding(). Nothing provided means the studio page,
 * so the sections still work dropped in anywhere on their own.
 */
import { inject, provide } from "vue";
import { fitnessLanding } from "../content/landings/fitness";

const LANDING = Symbol("landing");

export function provideLanding(landing) {
  provide(LANDING, landing);
}

export function useLanding() {
  return inject(LANDING, fitnessLanding);
}
